import { createApp } from 'vue';
import InvestorSharePriceCardApp from './InvestorSharePriceCard.vue';
import "./InvestorQuickLinkBlock.scss";
import "./FeaturedReportCard.scss";

const mountingDocumentArchiveBlocks = document.querySelectorAll('[data-feature="investor-shareprice-card"]');
mountingDocumentArchiveBlocks.forEach(block => {
	if (block) {
		const app = createApp({
			name: 'InvestorSharePriceCardApp',
		});
		app.component('investor-shareprice-card', InvestorSharePriceCardApp);
		app.mount(block);
	}
});
